// Studio application JavaScript entry — the webpack equivalent of the Sprockets
// app/assets/javascripts/application.js.coffee.erb manifest.
//
// Translates its Sprockets directives into imports:
//   #= require_self          -> ./application.coffee (manifest body)
//   #= require_tree ./…      -> require.context over the tree
//   #= require <controller>  -> per-controller import
//
// The plain .coffee files are consumed in place from ../legacy (coffee-loader).
// The former .coffee.erb files were copied into this directory with their ERB
// resolved (see ./application.coffee, ./campaigns.coffee,
// ./segmentation_criterias.coffee, ./concerns/{tools,ui}.coffee).

// Codegen'd globals (window.I18n.translations).
import "../generated/i18n_translations.js";

// require_self: the manifest body (window.t, Highcharts defaults, DOM-ready
// wiring). Kept as CoffeeScript.
import "./application.coffee";

// The two concern files that had ERB, with their server switches resolved.
import "./concerns/tools.coffee";
import "./concerns/ui.coffee";

// require_tree ./concerns, ./subscribers, ./web_forms (plain .coffee only; the
// .coffee.erb concerns above are excluded by the /\.coffee$/ test).
function importAll(context) {
  context.keys().forEach(context);
}
importAll(require.context("../legacy/concerns", true, /\.coffee$/));
importAll(require.context("../legacy/subscribers", true, /\.coffee$/));
importAll(require.context("../legacy/web_forms", true, /\.coffee$/));

// Per-controller top-level files (attachments, autoresponders, custom_fields,
// organizations, seed_lists, special_sending_rules, statistics,
// subscriber_exports/imports, subscription_web_forms, suppressed_*,
// suppression_lists, users). Non-recursive; campaigns/segmentation_criterias
// are .coffee.erb and handled below.
importAll(require.context("../legacy", false, /\.js\.coffee$/));

// The two controllers that had ERB (spinner image_path), copied + resolved.
import "./campaigns.coffee";
import "./segmentation_criterias.coffee";
